__turbopack_context__.v({
  "background": "_71B27q_background",
  "foreground": "_71B27q_foreground",
  "hero": "_71B27q_hero",
  "image": "_71B27q_image",
  "image-overlay": "_71B27q_image-overlay",
  "simulation-form": "_71B27q_simulation-form",
  "title": "_71B27q_title",
});
